$(function () {
	APP.init();

	// init
	lozadInit();
	fancyboxInit();

	accordionInit();
	loadMoreInit();
	recruitmentApplyTitle();
	$('.ruInputs input[type="button"]').on('click', function () {
		console.log('click');
		return false;
	});
	try {
		var observerForm = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				if (mutation.type === "childList") {
					$(".wrap-form").each(function () {
						let captchaContainer = $(this).find(".frm-captcha");
						let submitContainer = $(this).find(".frm-btnwrap");
						let wrapBottom = $(this).find(".wrap-bottom");
						if($(wrapBottom).length > 0){
							$(wrapBottom).append($(captchaContainer));
							$(wrapBottom).append($(submitContainer));
						}else{
							$(captchaContainer).prepend($(submitContainer));
						}
					});
				}
			});
		});

		observerForm.observe(
			document.querySelector(".form-container .ModuleContent > div"),
			{
				childList: true,
			}
		);

		$(".wrap-form").each(function () {
			let captchaContainer = $(this).find(".frm-captcha");
			let submitContainer = $(this).find(".frm-btnwrap");
			let wrapBottom = $(this).find(".wrap-bottom");
			if($(wrapBottom).length > 0){
				$(wrapBottom).append($(captchaContainer));
				$(wrapBottom).append($(submitContainer));
			}else{
				$(captchaContainer).prepend($(submitContainer));
			}
		});

	} catch (error) { }
	menuSpyInit();
	toggleMenuSpy();
	$('.full-content table').each(function () {
		$(this).wrap('<div class="table-responsive"></div>');
	});
	$('.select-water-supply select').on('change', function () {
		const waterSupplyTitle = $(this).val();
		$('#water-supply').text(waterSupplyTitle);
	});
});

$(window).on('scroll', function () {
	APP.fixed();
});

// variable
var header = $("header"),
	backdrop = $(".backdrop"),
	backToTop = $(".back-to-top"),
	buttonMenu = $("#buttonMenu"),
	mobileWrap = $(".mobile-wrap"),
	buttonSearch = $("header .button-search"),
	searchWrap = $(".search-wrap"),
	heightHeader = $("header").height(),
	heightWindow = $(window).height(),
	widthWindow = $(window).width(),
	outerHeightWindow = $(window).outerHeight();

// toggleText
$.fn.extend({
	toggleText: function (a, b) {
		return this.text(this.text() == b ? a : b);
	},
});

var APP = {
	fixed: () => {
		// header
		$(window).scrollTop() > heightHeader
			? header.addClass("active")
			: header.removeClass("active");
		$(window).scrollTop() > (outerHeightWindow - heightHeader)
			? backToTop.addClass("active")
			: backToTop.removeClass("active");
	},
	backdrop: () => {
		backdrop.on('click', function () {
			$(this).removeClass('open');
			buttonMenu.removeClass('open'); // close button menu
			mobileWrap.removeClass("open"); // close mobile menu
		})
	},
	background: () => {
		$('[data-bg]').each(function () {
			var image = $(this).data('bg');
			$(this).css({
				'background-image': 'url(' + image + ')'
			}).addClass('bg-cover bg-no-repeat bg-center');
		});
	},
	backToTop: () => {
		backToTop.on('click', function () {
			$('html, body').animate({ scrollTop: 0 }, 500);
		})
	},
	mapping: () => {
		const mainMenu = $("header .navbar-nav .menu-list").mapping({
			mobileWrapper: ".mobile-wrap .navbar-nav-list",
			mobileMethod: "appendTo",
			desktopWrapper: "header .navbar-nav",
			desktopMethod: "prependTo",
			breakpoint: 1279.98,
		});
		const menuTop = $("header .navbar-top .menu-list").mapping({
			mobileWrapper: ".mobile-wrap .navbar-nav-list",
			mobileMethod: "appendTo",
			desktopWrapper: "header .navbar-top",
			desktopMethod: "prependTo",
			breakpoint: 1279.98,
		});
		const volatility = $("header .volatility").mapping({
			mobileWrapper: ".mobile-wrap .mobile-bot",
			mobileMethod: "appendTo",
			desktopWrapper: "header .navbar-top",
			desktopMethod: "insertAfter",
			breakpoint: 1279.98,
		});
		const buttonContact = $("header .button-contact").mapping({
			mobileWrapper: ".mobile-wrap .mobile-bot",
			mobileMethod: "appendTo",
			desktopWrapper: "header .button-language",
			desktopMethod: "insertAfter",
			breakpoint: 1279.98,
		});
	},
	toggleDropdown: () => {
		const dropdown = $(".dropdown"),
			dropdownToggle = $(".dropdown-toggle"),
			dropdownMenu = $(".dropdown-menu");
		dropdownToggle.on("click", function () {
			$(this).toggleClass("active");
			$(this).parents('.dropdown').find('.dropdown-menu').toggleClass("open");
		});
	},
	toggleMegaMenu: () => {
		buttonMenu.on("click", function () {
			$(this).toggleClass("open");
			backdrop.toggleClass("open");
			mobileWrap.toggleClass("open");
		});
		// init icon mega menu
		$(".mobile-wrap .menu-list .has-mega > a").each(function () {
			$(this).after('<i class="fa-light fa-chevron-down mega-toggle-icon"></i>');
		});

		$(".mobile-wrap .menu-list .has-children > a").each(function () {
			$(this).after('<i class="fa-light fa-chevron-down mega-toggle-icon"></i>');
		});
		// toggle mega menu
		$(".mobile-wrap .menu-list .mega-toggle-icon").on("click", function () {
			$(this).toggleClass('active').next().slideToggle().parent().siblings().find('.mega-toggle-icon').removeClass('active').next().slideUp();
		});

		$("header .navbar-nav .menu-list li.has-mega.mega-dropdown-service").hover(function () {
			$(this).find('.mega-dropdown .has-children:first-child').addClass('hover');
			$(this).find('> .mega-dropdown').height($(this).find('.mega-dropdown .has-children:first-child .children-dropdown').height());
		});
		$("header .navbar-nav .menu-list li.has-mega.mega-dropdown-service").mouseleave(function () {
			$(this).find('.mega-dropdown .has-children:first-child').removeClass('hover');
			$(this).find('> .mega-dropdown').height(0);
		});
		$("header .navbar-nav .menu-list li.has-mega.mega-dropdown-service .mega-dropdown .has-children").hover(function () {
			$(this).addClass('hover').siblings().removeClass('hover');
		});
		$("header .navbar-nav .menu-list li.has-mega.mega-dropdown-service .mega-dropdown .has-children").mouseleave(function () {
			$(this).removeClass('hover').siblings().removeClass('hover');
		});
	},
	toggleSearch: () => {
		buttonSearch.on("click", function () {
			$(this).toggleClass("open");
			searchWrap.toggleClass("open");
		});
	},
	sourceInfo: () => {
		console.log(
			"%cBiwase",
			"font-size:100px;color:#2B4FA2;text-shadow:0 1px 0 #00AEEF,0 2px 0 #00AEEF ,0 3px 0 #00AEEF ,0 4px 0 #00AEEF ,0 5px 0 #00AEEF ,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);"
		);
		console.log(
			"%c Biwase %c - Biwase in Viet Nam",
			"border-radius: 2px; padding: 3px; background: #2B4FA2; color: #000",
			"color: #2B4FA2"
		);
	},
	init: () => {
		APP.backdrop();
		APP.background();
		APP.backToTop();
		APP.mapping();
		APP.toggleDropdown();
		APP.toggleMegaMenu();
		APP.toggleSearch();
		APP.sourceInfo();
	}
}

const homeBannerSlider = new Swiper(".home-banner .swiper", {
	loop: true,
	// autoplay: {
	// 	delay: 5000,
	// 	disableOnInteraction: false,
	// 	// pauseOnMouseEnter: true,
	// },
	speed: 1000,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-banner .button-next",
		prevEl: ".home-banner .button-prev",
	},
	pagination: {
		el: ".home-banner .swiper-pagination",
		clickable: true,
	},
});

const homeProductCateSlider = new Swiper(".home-product-categories .swiper", {
	speed: 1000,
	spaceBetween: 30,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-product-categories .button-next",
		prevEl: ".home-product-categories .button-prev",
	},
	pagination: {
		el: ".home-product-categories .swiper-pagination",
		clickable: true,
	},
	scrollbar: {
		el: ".home-product-categories .swiper-scrollbar",
		hide: false,
		draggable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 30,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 4,
			spaceBetween: 20,
		},
		1440: {
			slidesPerView: 4,
			spaceBetween: 30,
		},
	},
});

const projectDetailSlider = new Swiper(".project-detail-section .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		// pauseOnMouseEnter: true,
	},
	speed: 1000,
	spaceBetween: 10,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".project-detail-section .button-next",
		prevEl: ".project-detail-section .button-prev",
	},
	pagination: {
		el: ".project-detail-section .swiper-pagination",
		clickable: true,
	},
});

const projectOtherSlider = new Swiper(".project-other-section .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		// pauseOnMouseEnter: true,
	},
	speed: 1000,
	spaceBetween: 10,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".project-other-section .button-next",
		prevEl: ".project-other-section .button-prev",
	},
	pagination: {
		el: ".project-other-section .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
		},
		1024: {
			slidesPerView: 3,
		},
	},
});

const newsOtherSlider = new Swiper(".news-other-wrap .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		// pauseOnMouseEnter: true,
	},
	speed: 1000,
	spaceBetween: 30,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".news-other-wrap .button-next",
		prevEl: ".news-other-wrap .button-prev",
	},
	pagination: {
		el: ".news-other-wrap .swiper-pagination",
		clickable: true,
		dynamicBullets: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
		},
		1024: {
			slidesPerView: 3,
		},
	},
});

const homeNewsSlider = new Swiper(".home-news .swiper-news-top .swiper", {
	// loop: true,
	// autoplay: {
	// 	delay: 5000,
	// 	disableOnInteraction: false,
	// 	pauseOnMouseEnter: true,
	// },
	speed: 1000,
	spaceBetween: 30,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-news .swiper-news-top .button-next",
		prevEl: ".home-news .swiper-news-top .button-prev",
	},
	pagination: {
		el: ".home-news .swiper-news-top .swiper-pagination",
		clickable: true,
		dynamicBullets: true,
	},
	breakpoints: {
		768: {
			slidesPerView: 2,
		},
	},
});

const homeNews4Slider = new Swiper(".home-news .news-notification-group .swiper", {
	// loop: true,
	// autoplay: {
	// 	delay: 5000,
	// 	disableOnInteraction: false,
	// 	pauseOnMouseEnter: true,
	// },
	speed: 1000,
	spaceBetween: 30,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-news .news-notification-group .button-next",
		prevEl: ".home-news .news-notification-group .button-prev",
	},
	pagination: {
		el: ".home-news .news-notification-group .swiper-pagination",
		clickable: true,
	},
});

function lozadInit() {
	// Initialize library to lazy load images
	const observer = lozad('.lozad', {
		threshold: 0.1,
		// enableAutoReload: true,
	})

	// Picture observer
	// with default `load` method
	const pictureObserver = lozad('.lozad-picture', {
		threshold: 0.1
	})

	// Background observer
	// with default `load` method
	const backgroundObserver = lozad('.lozad-background', {
		threshold: 0.1
	})

	observer.observe()
	pictureObserver.observe()
	backgroundObserver.observe()
}

function fancyboxInit() {
	Fancybox.bind("[data-fancybox]", {
		showLoading: true,
		preload: true,
		infinite: false,
		parentEl: document.forms[0], // Element containing main structure
		mainClass: "fancybox-wrapper", // Custom class name or multiple space-separated class names for the container
	});

	Fancybox.bind("a.popup-link", {
		showLoading: true,
		type: "iframe",
		preload: true,
	});

	Fancybox.bind('[data-fancybox="single"]', {
		groupAttr: false,
	});

	$(".btn-close-fancybox").on("click", function () {
		Fancybox.close();
	});
}

function menuSpyInit() {
	if ($('.navbar-menu-spy').length) {
		$('html, body').addClass('scroll-smooth');
		var elm = document.querySelector('.navbar-menu-spy');

		var lavalampElm = document.querySelector('.lavalamp');
		var positionLavalamp = function (activeElm) {
			if (widthWindow >= 1280) {
				lavalampElm.style.width = activeElm.elm.offsetWidth + 'px';
				lavalampElm.style.left = activeElm.elm.offsetLeft + 'px';
			}
		};
		var ms = new MenuSpy(elm, {
			threshold: 120,
			callback: positionLavalamp,
		});
		positionLavalamp({ elm: elm.querySelector('li.active') });
	}
}

function equalHeight(el) {
	var height = 0;
	$(el).each(function () {
		var thisHeight = $(this).height();
		if (thisHeight > height) {
			height = thisHeight;
		}
		setTimeout(() => {
			$(el).height(height)
		}, 100)
	})
}

function checkCookie(cookieName) {
	let cookie = getCookie(cookieName);
	$('.exp a').on('click', function () {
		var dataExp = $(this).data('exp');
		setCookie("exp", dataExp, 1);
	});
	if (cookie != "") {
	} else {
	}
}

function countStart(el, num) {
	const options = {
		separator: '.',
		enableScrollSpy: true, // if true -> turn off countUp.start() after first scroll spy check
		scrollSpyDelay: 500, // delay for scroll spy check
		scrollSpyOnce: true,
	};

	let countUp = new CountUp(el, num, options);

	if (!countUp.error) {
		// countUp.start(() => console.log('Complete!'));
	} else {
		console.error(countUp.error);
	}
}

function countUpInit() {
	const elNumber = $(".count-number-current");
	if (elNumber)
		elNumber.each(function (index) {
			let dataCount = $(elNumber[index]).data('count');
			countStart(elNumber[index], dataCount);
		})
}

function accordionInit() {
	$('.accordion-item .accordion-header').on('click', function () {
		$(this).parent()
			.toggleClass('active')
			.siblings().removeClass('active')
		$(this)
			.toggleClass('active')
			.parents('.accordion-item')
			.siblings().find('.accordion-header').removeClass('active')
		$(this).parent()
			.find('.accordion-content').slideToggle()
			.parents('.accordion-item')
			.siblings().find('.accordion-content').slideUp('active')
	});
}

function loadMoreInit() {
	$('.load-more-wrap').each(function () {
		var button = $(this).find('.btn-load-more');
		var contentItem = $(this).find('.load-more-item');
		var contentItemLength = contentItem.length;
		var contentItemShow = $(this).data('show');
		var contentItemLoad = $(this).data('load');
		contentItem.slice(contentItemShow, contentItemLength).addClass('hidden');
		button.on('click', function (e) {
			e.preventDefault();
			console.log('load more click');
			var $thisLoadMore = $(this).parents('.load-more-wrap');
			var visibleItem = $thisLoadMore.find('.load-more-item:visible').length;
			var hiddenItem = $thisLoadMore.find('.load-more-item:hidden').length;
			contentItem.slice(0, (visibleItem + contentItemLoad)).slideDown();
			if (hiddenItem <= contentItemLoad) {
				$(this).hide();
			}
		})
	});
	$('.load-more-table-wrap').each(function () {
		var button = $(this).find('.btn-load-more-table');
		var contentItem = $(this).find('.load-more-table-item');
		var contentItemShow = 10;
		var contentItemLoad = 10;
		var contentItemLength = contentItem.length;
		contentItem.slice(contentItemShow, contentItemLength).addClass('hidden');
		button.on('click', function (e) {
			e.preventDefault();
			console.log('load more table click');
			var $thisLoadMore = $(this).parents('.load-more-table-wrap');
			var visibleItem = $thisLoadMore.find('.load-more-table-item:visible').length;
			var hiddenItem = $thisLoadMore.find('.load-more-table-item:hidden').length;
			contentItem.slice(contentItemLoad, (visibleItem + contentItemLoad)).addClass('show');
			if (hiddenItem <= contentItemLoad) {
				$(this).hide();
			}
		})
	});
	// move html
	$('.news-detail-page .recruitment-html-box').insertBefore('.recruitment-detail-section .recruitment-other-box');
}

function toggleMenuSpy() {
	$('.navbar-menu-spy .menu-spy-title').on('click', function () {
		$(this).toggleClass('active');
		$(this).parents('.navbar-menu-spy').find('.menu-spy-list').slideToggle();
	});
	$('.navbar-menu-spy .menu-spy-list li a').on('click', function () {
		if (widthWindow < 1024) {
			$(this).parents('.navbar-menu-spy').find('.menu-spy-title').removeClass('active');
			$(this).parents('.navbar-menu-spy').find('.menu-spy-list').slideUp();
		}
	});
}

function recruitmentApplyTitle() {
	$('.career-item .btn-apply').on('click', function () {
		let recruitmentTitle = $(this).parents('.career-item').find('.career-title').text();
		$('.modal-apply .apply-title').text(recruitmentTitle)
		$('.modal-apply .form-group.recruitment-apply-title input').attr('disable', 'disable').attr('readonly', 'readonly').val(recruitmentTitle)
	});
}

// function getIframeContent() {
// 	setTimeout(function () {
// 		var iframe = document.getElementById("fan-quote-191");
// 		// var elmnt = iframe.contentWindow.document.getElementsByTagName("div")[0];

// 		console.log("frame content : " + iframe.length);
// 	}), 5000;
// }
// getIframeContent()
